import React from "react";
import EYTopNavBar from "components/EYTopNavBar";
import MagicLinkGeneratorContainer from "UserAuthorized/components/containers/MagicLinkGeneratorContainer";
import MyLinkContainer from "UserAuthorized/components/containers/MyLinkContainer";
import { Router, Route, Switch } from "react-router-dom";
import RFETimeout from "../AuthorizeLink/components/RFETimeout";
import { history } from "../helpers";

class UserAuthorized extends React.Component {
  render() {
    const { userInfo } = this.props;
    return (
      <React.Fragment>
        <EYTopNavBar
          userInfo={userInfo}
          signOut={this.signOut}
          displayUser={true}
        />
        <div className="container is-fullhd">
          <div className="columns is-centered is-multiline">
            <div className="column is-12" />
            <div className="column is-half">
              <Router history={history}>
                <Switch>
                  <Route
                    path="/user/generatelink"
                    render={() => <MagicLinkGeneratorContainer />}
                  />
                  <Route
                    path="/user/mylinks"
                    render={() => <MyLinkContainer />}
                  />
                  <Route path="/timeout" component={RFETimeout} />
                  <Route render={() => <MagicLinkGeneratorContainer />} />
                </Switch>
              </Router>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default UserAuthorized;
